<template>
  <section class="page-container">
    <!--工具条-->
    <div ref="toolbar" class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-select
            v-model="filters.place"
            placeholder="广告位"
            clearable
            @change="changePlaceFilter"
          >
            <el-option label="商城" value="MALL"></el-option>
            <el-option label="老版本首页" value="OLD"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            v-if="filters.place === 'MALL'"
            v-model="filters.placeId"
            placeholder="广告位ID"
            clearable
            @change="list"
          >
            <el-option
              v-for="item in rootCats"
              :key="item.id"
              style="width: 400px"
              :value="item.id"
              :label="item.name"
            />
          </el-select>
          <el-input v-else v-model="filters.placeId" placeholder="广告位ID" />
        </el-form-item>
        <el-form-item>
          <status-select v-model="filters.status" @input="list" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="list">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd">新增</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--列表-->
    <div ref="mainContent" :style="{ height: mainHeight }">
      <el-table
        v-loading="listLoading"
        height="100%"
        :data="results"
        highlight-current-row
        border
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="ID" width="100"></el-table-column>
        <el-table-column prop="place" label="广告位" width="250">
          <template slot-scope="scope">
            <el-descriptions :column="1" border>
              <el-descriptions-item label="广告位">{{ scope.row.place }}</el-descriptions-item>
              <el-descriptions-item label="广告位ID">{{ scope.row.placeId }}</el-descriptions-item>
              <el-descriptions-item label="描述">{{ scope.row.placeDesc }}</el-descriptions-item>
            </el-descriptions>
          </template>
        </el-table-column>
        <el-table-column prop="image" label="信息">
          <template slot-scope="scope">
            <el-descriptions :column="1" border>
              <el-descriptions-item label="类型">
                <span v-fi="scope.row.type == 1">H5</span>
                <span v-fi="scope.row.type == 2">新闻页</span>
                <span v-fi="scope.row.type == 3">商品分类</span>
                <span v-fi="scope.row.type == 4">商品详情</span>
              </el-descriptions-item>
              <el-descriptions-item label="标题">{{ scope.row.title }}</el-descriptions-item>
              <el-descriptions-item label="图片">
                <el-image
                  v-if="scope.row.image"
                  :src="scope.row.image"
                  :preview-src-list="[scope.row.image]"
                  fit="cover"
                />
              </el-descriptions-item>
              <el-descriptions-item label="链接">{{ scope.row.link }}</el-descriptions-item>
              <el-descriptions-item label="iOS链接">{{ scope.row.iosLink }}</el-descriptions-item>
              <el-descriptions-item label="Android链接">{{
                scope.row.androidLink
              }}</el-descriptions-item>
              <el-descriptions-item label="排序">{{ scope.row.sortNo }}</el-descriptions-item>
              <el-descriptions-item label="状态">
                {{ scope.row.status | status }}
              </el-descriptions-item>
              <el-descriptions-item label="更新时间">
                {{ scope.row.updateTime | formatDate }}
              </el-descriptions-item>
              <el-descriptions-item label="创建时间">
                {{ scope.row.createTime | formatDate }}
              </el-descriptions-item>
            </el-descriptions>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-dropdown type="primary" @command="handleCommand">
              <el-button type="primary" size="mini">
                操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{ type: 'edit', index: scope.$index, data: scope.row }"
                  >编辑</el-dropdown-item
                >
                <el-dropdown-item
                  :command="{ type: 'delete', index: scope.$index, data: scope.row }"
                  >删除</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <my-pagination
      ref="pagebar"
      :page="page"
      @current-change="handlePageChange"
      @size-change="handleLimitChange"
    />

    <!--新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
      <el-form ref="addForm" :model="addForm" label-width="120px">
        <el-form-item label="广告位">
          <el-select
            v-model="addForm.place"
            placeholder="广告位"
            clearable
            @change="changeAddPlace"
          >
            <el-option label="商城" value="MALL"></el-option>
            <el-option label="老版本首页" value="OLD"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="广告位ID">
          <el-select
            v-if="addForm.place === 'MALL'"
            v-model="addForm.placeId"
            placeholder="广告位ID"
            clearable
            @change="list"
          >
            <el-option
              v-for="item in rootCats"
              :key="item.id"
              style="width: 400px"
              :value="item.id"
              :label="item.name"
            />
          </el-select>
          <el-input v-else v-model="addForm.placeId" placeholder="广告位ID" />
        </el-form-item>
        <el-form-item label="标题">
          <el-input v-model="addForm.title"></el-input>
        </el-form-item>
        <el-form-item label="图片">
          <image-upload v-model="addForm.image" />
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="addForm.type">
            <el-option :value="1" label="H5" />
            <el-option :value="2" label="新闻页" />
            <el-option :value="3" label="商品分类" />
            <el-option :value="4" label="商品详情" />
          </el-select>
        </el-form-item>
        <el-form-item label="链接">
          <el-input v-model="addForm.link"></el-input>
        </el-form-item>
        <el-form-item label="iOS链接">
          <el-input v-model="addForm.iosLink"></el-input>
        </el-form-item>
        <el-form-item label="安卓链接">
          <el-input v-model="addForm.androidLink"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="addForm.sortNo" placeholder="越小越靠前"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="addLoading" @click.native="addSubmit">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
      <el-form ref="editForm" :model="editForm" label-width="120px">
        <el-input v-model="editForm.id" type="hidden"></el-input>
        <el-form-item label="广告位">
          <el-select v-model="editForm.place" placeholder="广告位" disabled>
            <el-option label="商城" value="MALL"></el-option>
            <el-option label="老版本首页" value="OLD"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="广告位ID">
          <el-input v-model="editForm.placeId" readonly></el-input>
        </el-form-item>
        <el-form-item label="标题">
          <el-input v-model="editForm.title"></el-input>
        </el-form-item>
        <el-form-item label="图片">
          <image-upload v-model="editForm.image" />
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="editForm.type">
            <el-option :value="1" label="H5" />
            <el-option :value="2" label="新闻页" />
            <el-option :value="3" label="商品分类" />
            <el-option :value="4" label="商品详情" />
          </el-select>
        </el-form-item>
        <el-form-item label="链接">
          <el-input v-model="editForm.link"></el-input>
        </el-form-item>
        <el-form-item label="iOS链接">
          <el-input v-model="editForm.iosLink"></el-input>
        </el-form-item>
        <el-form-item label="安卓链接">
          <el-input v-model="editForm.androidLink"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <status-select v-model="editForm.status" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="editForm.sortNo" placeholder="越小越靠前"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" :loading="editLoading" @click.native="editSubmit">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import MyPagination from "@/components/MyPagination";
import StatusSelect from "@/components/StatusSelect";
import ImageUpload from "@/components/ImageUpload";
import mainHeight from "@/utils/mainHeight";
export default {
  name: "Banner",
  components: { MyPagination, StatusSelect, ImageUpload },
  data() {
    return {
      mainHeight: "300px",
      results: [],
      listLoading: false,
      page: {},
      filters: {
        status: 10,
      },
      selectedRows: [],

      addForm: {},
      addFormVisible: false,
      addLoading: false,

      editForm: {},
      editFormVisible: false,
      editLoading: false,

      rootCats: [],
    };
  },
  mounted() {
    mainHeight(this);
    this.list();
  },
  methods: {
    async changePlaceFilter() {
      this.filters.placeId = "";
      await this.loadRootCats();
      await this.list();
    },
    async loadRootCats() {
      this.rootCats = await this.axios.get("mall:/api/admin/product-category/rootCats");
    },
    async list() {
      this.listLoading = true;
      const params = Object.assign(this.filters, {
        page: this.page.page,
        limit: this.page.limit,
      });
      try {
        const data = await this.axios.form("mall:/api/admin/banner/list", params);
        this.results = data.results;
        this.page = data.page;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.listLoading = false;
      }
    },
    handleCommand(cmd) {
      switch (cmd.type) {
        case "edit":
          this.handleEdit(cmd.index, cmd.data);
          break;
        case "delete":
          this.deleteSubmit(cmd.index, cmd.data);
          break;
        default:
          break;
      }
    },
    async handleAdd() {
      this.addForm = {};
      this.addFormVisible = true;
      await this.loadRootCats();
    },
    async changeAddPlace() {
      this.addForm.placeId = "";
      await this.loadRootCats();
    },
    async addSubmit() {
      this.addLoading = true;
      try {
        await this.axios.post("mall:/api/admin/banner/create", this.addForm);
        this.$message({ message: "提交成功", type: "success" });
        this.addFormVisible = false;
        await this.list();
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.addLoading = false;
      }
    },
    async handleEdit(index, row) {
      try {
        const data = await this.axios.get("mall:/api/admin/banner/" + row.id);
        this.editForm = Object.assign({}, data);
        this.editFormVisible = true;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async editSubmit() {
      this.editLoading = true;
      try {
        await this.axios.post("mall:/api/admin/banner/update", this.editForm);
        await this.list();
        this.editFormVisible = false;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.editLoading = false;
      }
    },
    async deleteSubmit(index, row) {
      const me = this;
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .delete("mall:/api/admin/banner/" + row.id)
            .then((data) => {
              me.$message({ message: "删除成功", type: "success" });
              me.list();
            })
            .catch((rsp) => {
              me.$elnotify.error({ title: "error ", message: rsp.message });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async handlePageChange(val) {
      this.page.page = val;
      await this.list();
    },
    async handleLimitChange(val) {
      this.page.limit = val;
      await this.list();
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
  },
};
</script>

<style lang="scss" scoped></style>
